import Canvas from 'diagram-js/lib/core/Canvas';

export class ZoomService {

    private zoomStep = 0.2;

    constructor(private canvas: Canvas) {
    }

    zoomOutCanvas() {
        if (this.getScaleOut() >= 0) {
            this.canvas.zoom(this.getScaleOut(), 'auto');
        }
    }

    zoomInCanvas() {
        this.canvas.zoom(this.getScaleIn(), 'auto');
    }


    private getScaleOut(): number {
        return this.getScale(-1);
    }

    private getScaleIn(){
      return this.getScale(1);
    }

    private getScale(constraint: number): number {
        return this.canvas.viewbox().scale + (constraint * this.zoomStep);
    }


}
